module.exports = __webpack_public_path__ + "static/media/HCRA v. LJM Decision - October 25 2024.833d2bb9.pdf";